const MAX_RETRY_COUNT = 3;
const RETRY_DELAY_MS = 500;

export { MAX_RETRY_COUNT, RETRY_DELAY_MS };
